import React, { useState, useEffect } from "react";
import { Link,useNavigate,NavLink } from "react-router-dom";
import { FiMenu, FiX, FiSearch, FiShoppingCart, FiHeart } from "react-icons/fi";
import { motion } from "framer-motion";
import { useAuth } from "../context/authContext";   // ← Import this
import { RxAvatar } from "react-icons/rx";
const DOMAIN_TABLES = ["Education", "Food", "Pharmacy", "Toys", "Devices"];
const API = process.env.REACT_APP_API_URL;

const fadeInUp = {
  hidden: { opacity: 0, y: 70 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: 'easeOut' }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.18, delayChildren: 0.2 }
  }
};

const navLinkVariants = {
  rest: { y: 0 },
  hover: { y: -2, transition: { duration: 0.3, type: 'spring', stiffness: 400 } }
};

function LandingPage() {
  const { isLoggedIn, user, handleLogout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeDomain, setActiveDomain] = useState(null);
  const [profileDrawerOpen, setProfileDrawerOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [categories, setCategories] = useState({});

  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
const [suggestions, setSuggestions] = useState([]);
const { products, cart, wishlist, fetchCart, fetchWishlist } = useAuth(); 
// Search Logic
useEffect(() => {
  if (!searchTerm.trim()) {
    setSuggestions([]);
    setShowSuggestions(false);
    return;
  }

  // Filter products by name or category
  const filtered = products
    .filter(product =>
      product.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.category?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .slice(0, 8);

  setSuggestions(filtered);
  setShowSuggestions(true);
}, [searchTerm, products]);

// Close suggestions when clicking outside
useEffect(() => {
  const handleClickOutside = (e) => {
    if (!e.target.closest('.relative')) {
      setShowSuggestions(false);
    }
  };
  document.addEventListener('click', handleClickOutside);
  return () => document.removeEventListener('click', handleClickOutside);
}, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      alert(`Searching for "${searchTerm}"`);
    }
  };
  useEffect(() => {
    setCartCount(cart?.length || 0);
    setWishlistCount(wishlist?.length || 0);
  }, [cart, wishlist]);
  const handleLogoutClick = () => {
    handleLogout();
    setProfileDrawerOpen(false);
  };
  const toggleDomain = async (domain) => {
    if (activeDomain === domain) {
      setActiveDomain(null);
      return;
    }

    setActiveDomain(domain);

    // Fetch categories only if not already loaded
    if (!categories[domain]) {
      try {
        const res = await fetch(`${API}/api/categories?domain=${domain}`);
        const data = await res.json();
        setCategories((prev) => ({
          ...prev,
          [domain]: data,
        }));
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    }
  };

  const navItems = [
    {name : 'Home', path: '/', isExternal: false},
    { name: 'Orders', path: '/orders', isExternal: false },
    { name: 'Contact Us', path: '/contact', isExternal: false },
    // { name: 'Sign Up', path: '/auth?tab=register', isExternal: false },
  ];
// Load categories for ALL domains when component mounts
useEffect(() => {
  const loadAllCategories = async () => {
    const newCategories = {};
    
    for (const domain of DOMAIN_TABLES) {
      try {
        const res = await fetch(`${API}/api/categories?domain=${domain}`);
        if (res.ok) {
          const data = await res.json();
          newCategories[domain] = data;
        }
      } catch (err) {
        console.error(`Failed to load categories for ${domain}:`, err);
        newCategories[domain] = []; // fallback
      }
    }
    
    setCategories(newCategories);
  };

  loadAllCategories();
}, []);
  return (
    <div className="min-h-screen bg-black text-white font-sans">
           {/* Modern Compact Navbar */}
      <motion.header
  initial={{ y: -100, opacity: 0 }}
  animate={{ y: 0, opacity: 1 }}
  transition={{ duration: 0.8, ease: 'easeOut' }}
  className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-xl border-b border-gray-800"
>
  <nav className="max-w-7xl mx-auto px-6 py-1">
    <div className="flex items-center justify-between">
     
      {/* Logo + All Button + Search */}
      <div className="flex items-center gap-6 flex-1">
        <motion.div
          className="text-3xl font-bold tracking-tighter cursor-pointer"
          whileHover={{ scale: 1.05 }}
          onClick={() => window.location.href = '/'}
        >
          <span className="text-red-600 mr-20">Amaravatee</span>
        </motion.div>

        {/* All Categories Dropdown - Click + Hover */}
{/* All Categories Dropdown */}
<div className="relative hidden md:block">
  <button
    onClick={() => setDropdownOpen(!dropdownOpen)}
    className="flex items-center gap-2 px-4 py-2.5 bg-gray-900 hover:bg-gray-800 border border-gray-700 hover:border-red-600 rounded-2xl text-sm font-medium text-white transition-all active:scale-95"
  >
    <span>All</span>
    <span className={`text-xs transition-transform duration-300 ${dropdownOpen ? 'rotate-180' : ''}`}>
      ▼
    </span>
  </button>

  {/* Top Dropdown Menu - 5 Domains in One Row */}
  {dropdownOpen && (
  <div className="absolute left-0 top-full mt-2 w-[920px] max-w-[92vw] bg-gray-950 border border-gray-700 rounded-2xl shadow-2xl z-[60] overflow-hidden">
    
    <div className="p-6"> {/* Reduced padding */}
      <div className="grid grid-cols-5 gap-x-6 gap-y-8"> {/* Tighter gaps */}
        {DOMAIN_TABLES.map((domain) => {
          const domainCats = categories[domain] || [];
          const displayCats = domainCats.slice(0, 5);
          const hasMore = domainCats.length > 5;

          return (
            <div key={domain} className="space-y-2"> {/* Reduced spacing */}
              {/* Domain Title - Smaller & Clean */}
              <Link
                to={`/${domain.toLowerCase()}`}
                className="block group"
                onClick={() => setDropdownOpen(false)}
              >
                <h3 className="font-semibold text-red-500 text-[18px] tracking-wide border-b border-gray-800 pb-1.5 mx-2">
                {domain}
              </h3>
              </Link>
              {/* Categories - Even Smaller & Compact */}
              <ul className="space-y-0.5 text-sm min-h-[140px]">
  {displayCats.length > 0 ? (
    displayCats.map((cat) => {
      const slug = cat.toLowerCase().replace(/\s+/g, "-");
      return (
        <li key={cat}>
          <Link
            to={`/${domain.toLowerCase()}?category=${slug}`}
            className="block py-1 -mx-4 text-gray-400 hover:text-white hover:bg-gray-900 rounded-lg transition-all text-[14px] leading-tight"
            onClick={() => setDropdownOpen(false)}
          >
            {cat}
          </Link>
        </li>
      );
    })
  ) : (
    <li className="text-gray-500 text-xs py-1">Loading...</li>
  )}
</ul>

              {hasMore && (
                <Link
                  to={`/${domain.toLowerCase()}`}
                  className="inline-block text-red-500 hover:text-red-400 text-[12px] font-medium mt-1 transition-colors"
                  onClick={() => setDropdownOpen(false)}
                >
                  View more →
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>

    {/* Simple Footer - Only Small Close Button */}
    <div className="border-t border-gray-800 px-6 py-3 bg-gray-900/70 flex justify-end">
      <button
        onClick={() => setDropdownOpen(false)}
        className=" hover:text-red-400 text-xs font-medium px-2.5 py-1.5 rounded-xl hover:bg-gray-800 transition-all flex items-center gap-1"
      >
        Close 
      </button>
    </div>
  </div>
)}
</div>

        {/* Search Bar */}
        {/* Improved Search Bar */}
<div className="relative flex-1 max-w-xl hidden md:block">
  <input
    type="text"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    onKeyDown={(e) => {
      if (e.key === 'Enter' && searchTerm.trim()) {
        navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
        setSearchTerm('');
      }
    }}
    onFocus={() => setShowSuggestions(true)}
    placeholder={
      window.location.pathname.includes('/pharmacy') 
        ? "Search in Pharmacy..." 
        : "Search everything..."
    }
    className="w-full bg-gray-900 border border-gray-700 focus:border-red-600 focus:ring-1 focus:ring-red-600 rounded-2xl py-2.5 px-5 pl-11 text-sm text-white placeholder-gray-400 transition-all"
  />
  <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />

  {/* Search Suggestions */}
  {showSuggestions && searchTerm.trim() && suggestions.length > 0 && (
    <div className="absolute top-full mt-2 w-full bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl z-[70] overflow-hidden max-h-80 overflow-y-auto">
      {suggestions.map((product) => (
        <Link
          key={product.id || product.product_id}
          to={`/product/${product.domain || 'medical'}/${product.id || product.product_id}`}
          onClick={() => {
            setSearchTerm('');
            setShowSuggestions(false);
          }}
          className="flex items-center gap-4 px-5 py-3.5 hover:bg-gray-800 border-b border-gray-800 last:border-0 transition-all"
        >
          <div className="w-10 h-10 bg-gray-800 rounded-lg overflow-hidden flex-shrink-0">
            {product.image_url && (
              <img 
                src={`${API}${product.image_url}`} 
                alt={product.name} 
                className="w-full h-full object-cover" 
              />
            )}
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-white text-sm font-medium truncate">{product.name}</h4>
            <p className="text-gray-400 text-xs mt-0.5">{product.category}</p>
          </div>
          {product.price && (
            <span className="text-red-500 font-medium text-sm">₹{product.price}</span>
          )}
        </Link>
      ))}
    </div>
  )}
</div>
      </div>

      {/* Right Side Navigation */}
      <div className="flex items-center gap-5">
        <ul className="hidden lg:flex items-center gap-6 xl:gap-8 text-lg font-semibold tracking-wide mt-3">
          {navItems.map((item) => (
    <motion.li
      key={item.name}
      variants={navLinkVariants}
      initial="rest"
      whileHover="hover"
      className="relative"
    >
      <NavLink
        to={item.path}
        className={({ isActive }) =>
          `relative transition-all duration-300 text-[16px] ${
            isActive
              ? "text-red-500 after:w-full"
              : "text-white hover:text-red-500"
          } after:content-[''] after:absolute after:h-0.5 after:bg-red-600 after:left-0 after:bottom-[-6px] after:transition-all after:duration-300 ${
            isActive ? "after:w-full" : "after:w-0 hover:after:w-full"
          }`
        }
      >
        {item.name}
      </NavLink>
    </motion.li>
  ))}
  <motion.li className="relative">
  <NavLink to="/wishlist">
    {({ isActive }) => (
      <div className="relative">
        <FiHeart
          className={`text-2xl transition-colors duration-300 ${
            isActive
              ? "text-red-500"
              : "text-white hover:text-red-500"
          }`}
        />

        {wishlistCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
            {wishlistCount}
          </span>
        )}
      </div>
    )}
  </NavLink>
</motion.li>

<motion.li className="relative">
  <NavLink to="/cart">
    {({ isActive }) => (
      <div className="relative">
        <FiShoppingCart
          className={`text-2xl transition-colors duration-300 ${
            isActive
              ? "text-red-500"
              : "text-white hover:text-red-500"
          }`}
        />

        {cartCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
            {cartCount}
          </span>
        )}
      </div>
    )}
  </NavLink>
</motion.li>
          {isLoggedIn ? (
                  <button
                    onClick={() => setProfileDrawerOpen(true)}
                    className="overflow-hidden border-2 border-gray-400 hover:border-red-600 transition-all flex items-center justify-center bg-gray-800
                    py-1 px-3 bg-transparent rounded-full" 
                  >
                    {user?.name ? (
                      <span className="text-white font-medium text-lg ">
                        {user.name.charAt(0).toUpperCase()}
                      </span>
                      
                    ) : (
                      <RxAvatar size={24} className="text-gray-300" />
                    )}
                  </button>
                ) : (
                  <Link
                    to="/auth?tab=register"
                    className="bg-red-600 hover:bg-red-700 px-6 py-2.5 rounded-2xl text-sm font-medium transition-all text-white"
                  >
                    Sign Up
                  </Link>
                )}
        </ul>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setSidebarOpen(true)}
          className="lg:hidden text-2xl p-1 text-white"
        >
          <FiMenu />
        </button>
      </div>
    </div>
  </nav>
</motion.header>
{profileDrawerOpen && (
        <div
          className="fixed inset-0 bg-black/70 z-[70]"
          onClick={() => setProfileDrawerOpen(false)}
        />
      )}

      {/* Drawer */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-gray-950 border-l border-gray-800 shadow-2xl z-[80] transform transition-transform duration-300 ${
          profileDrawerOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="p-6 border-b border-gray-800 flex items-center justify-between">
          <h3 className="text-lg font-medium text-white">Hello, {user?.name || "Guest"}</h3>
          <button
            onClick={() => setProfileDrawerOpen(false)}
            className="text-gray-400 hover:text-white  p-2 bg-transparent"
          >
            <FiX size={22}/>
          </button>
        </div>

        <div className="p-4">
          <Link
            to="/profile"
            onClick={() => setProfileDrawerOpen(false)}
            className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-gray-900 text-gray-300 hover:text-red-400 transition-all"
          >
            <RxAvatar size={24} />
            <span className="font-medium">My Profile</span>
          </Link>

          <button
            onClick={handleLogoutClick}
            className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-gray-900 text-gray-400 hover:text-red-400 w-full text-left transition-all bg-transparent "
          >
            <FiX size={24} className="rotate-45" />
            <span className="font-medium">Logout</span>
          </button>
        </div>
      </div>
      {/* Improved Modern Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full w-72 bg-gray-950 border-r border-gray-800 shadow-2xl z-[60] transform transition-transform duration-300 flex flex-col ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        {/* Sidebar Header */}
        <div className="px-6 py-5 border-b border-gray-800 flex items-center justify-between bg-gray-950 shrink-0">
          <h2 className="text-xl font-semibold text-white">Menu</h2>
          <button
            onClick={() => setSidebarOpen(false)}
            className="text-gray-400 hover:text-white text-2xl transition-colors"
          >
            <FiX />
          </button>
        </div>

        {/* Sidebar Content */}
        <div className="overflow-y-auto flex-1 px-3 pt-4 pb-12">
          {/* Mobile Search */}
          <div className="mb-6 px-2">
            <div className="relative w-full">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && searchTerm.trim()) {
                    navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
                    setSearchTerm('');
                    setSidebarOpen(false);
                  }
                }}
                placeholder="Search..."
                className="w-full bg-gray-900 border border-gray-700 focus:border-red-600 focus:ring-1 focus:ring-red-600 rounded-xl py-2.5 px-4 pl-10 text-sm text-white placeholder-gray-400 transition-all"
              />
              <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />
            </div>
          </div>

          {/* Mobile Navigation Links */}
          <div className="mb-6 px-2 space-y-2 border-b border-gray-800 pb-4">
            {navItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                onClick={() => setSidebarOpen(false)}
                className={({ isActive }) =>
                  `block px-4 py-2.5 rounded-xl font-medium transition-all ${
                    isActive ? "bg-gray-900 text-red-500" : "text-white hover:bg-gray-900 hover:text-red-500"
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
            
            {/* Wishlist & Cart */}
            <div className="flex justify-between items-center px-2 py-2 mt-2">
              <NavLink to="/wishlist" onClick={() => setSidebarOpen(false)} className="flex items-center gap-2 px-2 py-2 rounded-xl text-white hover:bg-gray-900 hover:text-red-500 relative transition-all">
                <FiHeart className="text-xl" />
                <span className="font-medium">Wishlist</span>
                {wishlistCount > 0 && (
                  <span className="bg-red-600 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full ml-1">
                    {wishlistCount}
                  </span>
                )}
              </NavLink>
              
              <NavLink to="/cart" onClick={() => setSidebarOpen(false)} className="flex items-center gap-2 px-2 py-2 rounded-xl text-white hover:bg-gray-900 hover:text-red-500 relative transition-all">
                <FiShoppingCart className="text-xl" />
                <span className="font-medium">Cart</span>
                {cartCount > 0 && (
                  <span className="bg-red-600 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full ml-1">
                    {cartCount}
                  </span>
                )}
              </NavLink>
            </div>

            {/* User Profile / Auth */}
            <div className="px-2 py-2 mt-2">
              {isLoggedIn ? (
                <button
                  onClick={() => { setSidebarOpen(false); setProfileDrawerOpen(true); }}
                  className="w-full flex items-center justify-center gap-2 bg-gray-800 hover:bg-gray-700 text-white py-2.5 rounded-xl transition-all"
                >
                  {user?.name ? (
                    <span className="w-6 h-6 flex items-center justify-center bg-gray-700 rounded-full text-sm font-medium">
                      {user.name.charAt(0).toUpperCase()}
                    </span>
                  ) : (
                    <RxAvatar size={20} className="text-gray-300" />
                  )}
                  <span className="font-medium">My Profile</span>
                </button>
              ) : (
                <Link
                  to="/auth?tab=register"
                  onClick={() => setSidebarOpen(false)}
                  className="w-full flex items-center justify-center bg-red-600 hover:bg-red-700 text-white py-2.5 rounded-xl text-sm font-medium transition-all"
                >
                  Sign Up
                </Link>
              )}
            </div>
          </div>

          <h3 className="text-sm font-semibold text-gray-400 px-3 mb-2 uppercase tracking-wider">Categories</h3>
          {DOMAIN_TABLES.map((domain) => (
            <div key={domain} className="mb-1">
              {/* Domain Item */}
              <div className="flex items-center justify-between w-full px-5 py-3 font-medium text-white rounded-2xl hover:bg-gray-900 transition-all group">
                <Link
                  to={`/${domain.toLowerCase()}`}
                  onClick={() => setSidebarOpen(false)}
                  className="flex-1 text-left group-hover:text-red-500 transition-colors"
                >
                  {domain}
                </Link>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleDomain(domain);
                  }}
                  className="pl-4 pr-2 text-xl text-gray-400 group-hover:text-red-500 transition-colors"
                >
                  {activeDomain === domain ? "−" : "+"}
                </button>
              </div>

              {/* Subcategories */}
              {activeDomain === domain && categories[domain] && (
                <div className="ml-6 mt-1 mb-4 border-l border-gray-800 pl-5">
                  <ul className="space-y-0.5">
                    {categories[domain].map((cat) => (
                      <li key={cat}>
                        <Link
                          to={`/${domain.toLowerCase()}?category=${cat.toLowerCase().replace(/\s+/g, "-")}`}
                          className="block px-4 py-2.5 text-sm text-gray-300 hover:text-red-500 hover:bg-gray-900 rounded-xl transition-all"
                          onClick={() => setSidebarOpen(false)}
                        >
                          {cat}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/70 z-50"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Improved Spacious Hero Section */}
      <section
        id="home"
        className="relative h-[650px] flex items-center justify-center bg-cover bg-center bg-no-repeat mt-2"
        style={{
          backgroundImage:
            "linear-gradient(to bottom, rgba(0,0,0,0.78), rgba(0,0,0,0.68)), url('https://i.ytimg.com/vi/Sgwr0Dd2mro/maxresdefault.jpg')",
        }}
      >
        <motion.div
          initial="hidden"
          animate="visible"
          variants={staggerContainer}
          className="text-center max-w-6xl px-6 md:px-10 lg:px-12"
        >
          <motion.h1
            variants={fadeInUp}
            className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold leading-tight md:leading-snug tracking-tight mt-10"
          >
            Welcome to <span className="text-red-600">Amaravatee</span>
          </motion.h1>
          <motion.p
            variants={fadeInUp}
            className="text-base sm:text-lg md:text-xl lg:text-2xl font-light text-gray-300/90 max-w-3xl mx-auto leading-relaxed mb-10 md:mb-14"
          >
            <span className="font-normal text-gray-100 block mb-2 sm:mb-3">
              One place for everything you need —
            </span>
            <span className="font-semibold text-white tracking-wide">
              Education · Food · Healthcare · Shopping · Careers
            </span>
            <span className="block mt-4 text-red-400 font-medium not-italic text-lg sm:text-xl md:text-2xl">
              All right here for you.
            </span>
          </motion.p>
          <motion.a
            href="#categories"
            variants={fadeInUp}
            whileHover={{ scale: 1.07, boxShadow: '0 25px 60px -15px rgba(220, 38, 38, 0.5)' }}
            whileTap={{ scale: 0.96 }}
            className="inline-block bg-red-600 hover:bg-red-700 text-white font-bold text-lg sm:text-xl md:text-xl px-10 md:px-6 py-3 md:py-3 rounded-full transition-all duration-400 shadow-2xl shadow-red-900/50 -mt-4"
          >
            Explore Now →
          </motion.a>
        </motion.div>
      </section>

      {/* Categories Section with scroll animation */}
      <section id="categories" className="py-28 md:py-14 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.35 }}
            variants={fadeInUp}
            className="text-5xl md:text-6xl lg:text-7xl font-bold text-center mb-16 md:mb-10 tracking-tight text-gray-900"
          >
            Everything You Need <span className="text-[#c8102e]">in One Place</span>
          </motion.h2>
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.15 }}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 xl:gap-12"
          >
            {[
              {
  title: 'Education',
  link: '/education',
  desc: 'Top courses, schools, universities, online learning platforms & skill development programs',
  img: 'https://dwrqao8j794zb.cloudfront.net/for-static-use/9f41b45a-e7c7-11f0-b7d7-dda6981ba314-f85f6fe9-772d-4361-a28e-c80dbcbaccc4-DSC05711.JPG' // or use one from below
},
{
  title: 'Food',
  link: '/food',
  desc: 'Restaurants, home-style recipes, grocery delivery, street food & authentic Andhra cuisine',
  img: 'https://images.unsplash.com/photo-1606491956689-2ea866880c84'
},
{
  title: 'Healthcare',
  link: '/pharmacy',
  desc: 'Hospitals, specialist doctors, pharmacies, telemedicine & wellness services',
  img: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d'
},
{
  title: 'Toys',
  link: '/toys',
  desc: 'Educational toys, games, building blocks, puzzles & play essentials for all ages',
  img: 'https://www.bellalunatoys.com/cdn/shop/collections/Blocks_and_Building.jpg?v=1773067495&width=2146'
},
{
  title: 'Devices',
  link: '/devices',
  desc: 'Smartphones, laptops, tablets, headphones, smart gadgets & latest electronics',
  img: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853'
},
            ].map((item, index) => (
              <motion.div
                key={item.title}
                onClick={() => navigate(item.link)}
                variants={fadeInUp}
                whileHover={{ y: -12, transition: { duration: 0.4 } }}
                className={`group bg-white border border-gray-200 rounded-3xl overflow-hidden transition-all duration-300 h-[450px] cursor-pointer
                  shadow-md hover:shadow-2xl hover:shadow-[#c8102e]/15 hover:border-[#c8102e]/50
                  ${index === 0 ? "lg:col-span-2" : ""}
                  ${index === 1 ? "lg:col-span-2" : ""}
                  ${index === 2 ? "lg:col-span-2" : ""}
                  ${index === 3 ? "lg:col-span-2 lg:col-start-2" : ""}
                  ${index === 4 ? "lg:col-span-2 lg:col-start-4" : ""}
                `}
              >
                <div
                  className="h-60 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
                  style={{ backgroundImage: `url('${item.img}')` }}
                />
                <div className="p-7 md:p-6 text-center">
                  <h3 className="text-3xl md:text-2xl font-bold mb-4 text-gray-900 group-hover:text-[#c8102e] transition-colors duration-300">
                    {item.title}
                  </h3>
                  <p className="text-gray-700 text-base md:text-lg leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <motion.footer
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="bg-black border-t border-gray-800 pt-20 pb-12 text-gray-400"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
            {/* Column 1: Logo + About */}
            <div className="lg:col-span-5">
              <div className="text-5xl font-bold tracking-tighter mb-4">
                <span className="text-[#e11d48]">Amaravatee</span>
              </div>
              <p className="text-gray-400 text-lg leading-relaxed max-w-md">
                Your one-stop destination for everything in Andhra Pradesh — Education, Food, Healthcare,
                Marketplace, Employment and more. Celebrating the culture, opportunities, and richness of our land.
              </p>
              {/* Social Icons */}
              <div className="flex gap-5 mt-10">
                <a href="#" className="text-3xl hover:text-[#c8102e] transition-colors" aria-label="Facebook">
                  <i className="bi bi-facebook"></i>
                </a>
                <a href="#" className="text-3xl hover:text-[#e11d48] transition-colors" aria-label="Instagram">
                  <i className="bi bi-instagram"></i>
                </a>
                <a href="#" className="text-3xl hover:text-[#e11d48] transition-colors" aria-label="Twitter">
                  <i className="bi bi-twitter"></i>
                </a>
                <a href="#" className="text-3xl hover:text-[#e11d48] transition-colors" aria-label="LinkedIn">
                  <i className="bi bi-linkedin"></i>
                </a>
                <a href="#" className="text-3xl hover:text-[#e11d48] transition-colors" aria-label="YouTube">
                  <i className="bi bi-youtube"></i>
                </a>
              </div>
            </div>

            {/* Column 2: Quick Links */}
            <div className="lg:col-span-2">
              <h5 className="text-white text-xl font-semibold mb-6">Quick Links</h5>
              <ul className="space-y-3 text-lg">
                {['Home', 'About Us', 'Contact', 'Blog'].map((link) => (
                  <li key={link}>
                    <a href="#" className="hover:text-[#c8102e] transition-colors">{link}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 3: Our Categories */}
            <div className="lg:col-span-3">
              <h5 className="text-white text-xl font-semibold mb-6">Explore Categories</h5>
              <ul className="space-y-3 text-lg">
                {['Education', 'Food', 'Pharmacy', 'Toys','Devices'].map((item) => (
                  <li key={item}>
                    <Link
          to={`/${item.toLowerCase()}`} // React Router link
          className="hover:text-[#e11d48] transition-colors"
        >
          {item}
        </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 4: Contact Info */}
            <div className="lg:col-span-2">
              <h5 className="text-white text-xl font-semibold mb-6">Get in Touch</h5>
              <ul className="space-y-4 text-base">
                <li className="flex items-center gap-3 hover:text-[#e11d48] transition text-red-500">
                  📍 <span>Andhra Pradesh, India</span>
                </li>
                <li className="flex items-center gap-3">
                  ✉️ <a href="mailto:hello@amaravatee.com" className="hover:text-[#e11d48] transition">hello@amaravatee.com</a>
                </li>
                <li className="flex items-center gap-3">
                  📞 <a href="tel:+918888888888" className="hover:text-[#e11d48] transition">+91 88888 88888</a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-20 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>
              © {new Date().getFullYear()} Amaravatee.com – All Rights Reserved
            </p>
            <p className="flex items-center gap-2">
              Made with <span className="text-[#e11d48] text-lg">❤️</span> for the people of Andhra Pradesh
            </p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-gray-300 transition">Privacy Policy</a>
              <a href="#" className="hover:text-gray-300 transition">Terms & Conditions</a>
            </div>
          </div>
        </div>
      </motion.footer>
    </div>
  );
}

export default LandingPage;